import { brandHandlers } from '~~base-ui';
import { documentHandlers } from '~~document';
import { requirmentHandlers } from '~~requirement';

import { coreHandlers } from './index';

export const handlers = [
  ...coreHandlers,
  ...brandHandlers(),
  ...documentHandlers,
  ...requirmentHandlers,
];
